// extracted by mini-css-extract-plugin
module.exports = {"sdks":"SDKS-module--sdks--t53kc","image":"SDKS-module--image--3uwZH","buttons":"SDKS-module--buttons--8cCs1","sdk":"SDKS-module--sdk--YpBQK"};